import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ModalDeleteAccount = ({ isOpen, toggle, handleConfirm, item }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Confirmación</ModalHeader>
            <ModalBody>
                <p>¿Estás seguro de que deseas eliminar la cuenta "{item.name}"?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={handleConfirm}>Sí</Button>
                <Button color="secondary" onClick={toggle}>No</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalDeleteAccount;